import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions } from './index';

export type ReportDeleteData = AnyObject;

export type ReportDeleteResponse = ReportDeleteData;

export interface ReportDelete {
  id: string;
}

export const reportDelete = (payload: ReportDelete): Action<ReportDelete> => ({
  type: actions.reportDeleteTrigger.toString(),
  payload,
});

export const reportDeleteClear = (): Action => ({
  type: actions.reportDeleteClear.toString(),
});

export function* reportDeleteRequestSaga({ payload }: Action<ReportDelete>) {
  yield put({
    type: actions.reportDeleteStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.reportDeleteError.toString(),
      payload: {
        message: 'ReportDelete: Parameters not passed.',
      },
    });

    return;
  }

  const { id } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/reports/${id}`,
    {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<ReportDeleteData, ReportDeleteResponse>(
    response,
    actions.reportDeleteSuccess.toString(),
    actions.reportDeleteError.toString(),
    false,
    (reportDeleteData) => reportDeleteData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.reportDeleteTrigger.toString(),
    defaultProcessingSaga(
      reportDeleteRequestSaga,
      {
        error: actions.reportDeleteError.toString(),
        locationCancel: actions.reportDeleteClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.reportDeleteSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }

    // yield put({
    //   type: actions.reportDeleteClear.toString(),
    // });
  });

  yield takeLatest(actions.reportDeleteError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.reportDeleteErrorReset.toString(),
    });
  });
}
